import { Injectable } from '@angular/core';
import {
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { environment } from './environment';

import { RadiantHttpInterceptor, HttpCancelService } from '@library/common/http';

@Injectable()
export class PaymentHttpInterceptor extends RadiantHttpInterceptor {
   constructor(
      cancelService: HttpCancelService,
   ) {
      super(cancelService);
   }

   origin(): string {
      return environment.origin;
   }

   lambda(): string {
      return environment.lambdaApi;
   }
   
   localLambda(): string {
      return environment.localLambdaApi;
   }
}

export let httpInterceptor2 = {
   provide: HTTP_INTERCEPTORS,
   useClass: PaymentHttpInterceptor,
   multi: true
};
